import React, { useEffect, useState } from "react";
import { ChevronUp } from "lucide-react";

// Floating "back to top": icon only, appears after scrolling, sits above sticky CTAs (offset in px) and respects iPhone safe-area.
export default function BackToTop({ offset = 24, threshold = 600 }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const on = () => setShow(window.scrollY > threshold);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, [threshold]);
  const go = () => window.scrollTo({ top: 0, behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" });
  return (
    <button type="button" onClick={go} aria-label="Torna all'inizio della pagina" title="Torna all'inizio" data-testid="back-to-top"
      className={`fixed right-4 z-[45] h-12 w-12 rounded-full bg-[#0c2d34] text-white shadow-[0_12px_30px_-10px_rgba(12,45,52,.6)] grid place-items-center transition-[opacity,transform] duration-300 motion-reduce:transition-none hover:bg-[#123C46] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[#8fd7c4]/60 ${show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"}`}
      style={{ bottom: `calc(${offset}px + env(safe-area-inset-bottom, 0px))` }} tabIndex={show ? 0 : -1} aria-hidden={!show}>
      <ChevronUp className="h-6 w-6" aria-hidden="true" />
    </button>
  );
}
